const isTraumApp = () => {
    if (typeof navigator !== 'undefined' && navigator.userAgent) {
        return navigator.userAgent.includes('traum_app')
    }
    return false
}

export default isTraumApp
